/** Presentations of the search result (Spec 120 E1) and their per-browser memory. */
export const BROWSE_VIEWS = ['table', 'tiles-large', 'tiles-small', 'tree'] as const;
export type BrowseView = (typeof BROWSE_VIEWS)[number];

const STORAGE_KEY = 'plc_browse_view';

export function isBrowseView(value: unknown): value is BrowseView {
  return BROWSE_VIEWS.includes(value as BrowseView);
}

export function readStoredBrowseView(): BrowseView {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isBrowseView(stored) ? stored : 'table';
  } catch {
    return 'table';
  }
}

export function storeBrowseView(view: BrowseView): void {
  try {
    localStorage.setItem(STORAGE_KEY, view);
  } catch {
    // localStorage unavailable (e.g. private browsing) — the switch still works for this session
  }
}
